webpackJsonp([263791100135453],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "issue" },
	    _react2.default.createElement(
	      "div",
	      { className: "sideBarLeft" },
	      _react2.default.createElement(
	        "div",
	        { className: "impressum" },
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/about/" },
	              "about"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/editorial/" },
	              "editorial"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/contact/" },
	              "contact"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "archive" },
	        _react2.default.createElement(
	          "a",
	          { href: "/archive/" },
	          "archive"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "core-content" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        "this is a monthly electronic art magazine. each issue is dedicated to a different topic."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "http://creativecommons.org/licenses/by-nc-sa/2.0/" },
	          _react2.default.createElement("img", { id: "license", src: "/style/default/somerights20.png", alt: "creativecommons license", border: "0" })
	        ),
	        " its users are its artists."
	      ),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "e-zine:format"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "the e-zine invites creative interpretations of a monthly changing topic. all submitted works are published indiscriminately. the contributors are free in their choice of form: graphic design, photography, movies, cartoons, texts, etc. the upload is carried out individually and the maximum space per submission is 400x400 pixels. the contributions are published under free copyright license."
	      ),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "i-love-u:idea"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "in 1997 the first issue \"ass\" of the e-zine was release by the i-love-u multimedia collective: basel, london, barcelona. the e-zine is conceived as an experimental platform, simple in use as a printed magazine. its approach to creative expression is openminded and playfully provocative. it furthers immediate and dynamic artistic production and its distribution is world wide."
	      ),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "i-love-u:layout"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "for designing a love-layout please ",
	        _react2.default.createElement(
	          "a",
	          { href: "mailto:layout@i-love-u.ch" },
	          "e-mail us"
	        ),
	        " ideas and drafts."
	      )
	    ),
	    _react2.default.createElement("div", { className: "nav-and-metadata" })
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-c55e43b019650d35befc.js